(function () {
    window.addEventListener('load', function () {
        let wWidth = window.innerWidth;
        let sliders = document.querySelectorAll('[data-carousel]');
        if (sliders.length) {
            sliders.forEach(function (elem) {
                let slider = tns({
                    container: elem,
                    items: 3,
                    slideBy: 1,
                    mode: 'carousel',
                    autoplay: true,
                    nav: false,
                    autoplayButtonOutput: false,
                    speed: 800,
                    prevButton: false,
                    nextButton: false,
                    responsive: {
                        1150: {
                            items: 4
                        },
                        1580: {
                            items: 5
                        },
                        1800: {
                            items: 6
                        }
                    }
                });

                let slides = parseInt(elem.getAttribute('data-carousel-slides'));

                if ( wWidth >= 1150 && wWidth <= 1579 && slides <= 4 ) {
                    slider.destroy();
                } else if ( wWidth >= 1580 && wWidth <= 1799 && slides <= 5 ) {
                    slider.destroy();
                } else if ( wWidth >= 1800 && slides <= 6 ) {
                    slider.destroy();
                }
            });



        }

    });
})()


//////////////////
// WEBPACK FOOTER
// ./js/modules/carousel.js
// module id = 11
// module chunks = 0